/**
 * Created by koqiui on 2017-04-09.
 */
import { Utils } from '../../app.base';
import { MsgBox, Vue } from '../../app.vues'

import devcApi from '../../api/devc';
//
import SwbContractLogList from './ContractLogList';
import SwbContractGoodsListForSelect from './ContractGoodsListForSelect';
import SwbContractListForSelect from './ContractListForSelect';
import SwbContractServcListForSelect from './ContractServcListForSelect';
import SwbContractGoodsAreaPriceSave from './ContractGoodsAreaPriceSave';
import SwbContractFormatExpl from './ContractFormatExpl';
import SwbContractImpCheck from './ContractImpCheck';
import SwbContractFeeItemForSelect from './ContractFeeItemForSelect';
import SwbContractModify from './ContractModify';
import SwbContractServcPurchModify from './ContractServcPurchModify';
import SwbContractServcOrgQuantityList from './ContractServcOrgQuantityList';
import SwbContractServcOrgPriceList from './ContractServcOrgPriceList';
import SwbContractServcOrgSpecList from './ContractServcOrgSpecList';
import SwbContractServcOrgPriceRecList from './ContractServcOrgPriceRecList';

Vue.regist(SwbContractServcOrgPriceRecList);

Vue.regist(SwbContractLogList);

Vue.regist(SwbContractGoodsListForSelect);

Vue.regist(SwbContractListForSelect);

Vue.regist(SwbContractServcListForSelect);

export function openContractLogListDlg(contractNo) {
    //
    Vue.$showDialog({
        title: '合同日志列表',
        showCloseBtn: true,
        width: '70%',
        height: 600,
        okVisible: false,
        cancelText: '关闭',
        template: '<div>' +
        '<swb-contract-log-list :contractNo="contractNo" ref="swb_contract_log_list"></swb-contract-log-list>' +
        '</div>',
        data: {
            contractNo: contractNo
        },
        methods: {},
        okClicked: function () {
        },
    });
}

// 设备关联初始合同，选择列表
export function openContractGoodsListDlg(dlgConfig, callback) {
    //
    let shopDeviceSvcSubNos = dlgConfig['shopDeviceSvcSubNos'] || [];
    let catId = dlgConfig['catId'];
    let brandId = dlgConfig['brandId'];
    let realComId = dlgConfig['realComId'];
    //
    Vue.$showDialog({
        title: '合同商品列表 - 选择',
        showCloseBtn: true,
        width: -300,
        height: 750,
        template: '<div>' +
        '<swb-contract-goods-list-for-select :realComId="realComId" :shopDeviceSvcSubNos="shopDeviceSvcSubNos" :catId="catId" :brandId="brandId" ref="swb_contract_goods_list_for_select"></swb-contract-goods-list-for-select>' +
        '</div>',
        data: {
            shopDeviceSvcSubNos: shopDeviceSvcSubNos,
            realComId: realComId,
            catId: catId,
            brandId: brandId
        },
        methods: {},
        okClicked: function () {
            let selfDlg = this;
            let result = selfDlg.$refs.swb_contract_goods_list_for_select.getDlgResult() || {};
            if(!Utils.isNoB(result) && result.type == 'info') {
                let resData = result.data;
                let theLoad = MsgBox.loading();
                devcApi.doShopDeviceRelContract(resData, function (res) {
                    theLoad.hide();
                    if(res.type == 'info') {
                        MsgBox.success('关联成功！');
                        callback(true);
                        //
                    } else {
                        MsgBox.warning(res.message);
                    }
                });
                return true;
            } else {
                MsgBox.warning(result.message);
                return false;
            }
        }
    });
}

export function openContractListForSelectDlg(filterms, callback) {
    //
    Vue.$showDialog({
        title: '合同列表 - 选择',
        showCloseBtn: true,
        width: -300,
        height: 750,
        template: '<div>' +
        '<swb-contract-list-for-select :params="filterms" ref="swb_contract_list_for_select"></swb-contract-list-for-select>' +
        '</div>',
        data: {
            filterms: filterms
        },
        methods: {},
        okClicked: function () {
            let selfDlg = this;
            let result = selfDlg.$refs.swb_contract_list_for_select.getDlgResult() || {};
            if(!Utils.isNoB(result) && result.type == 'info') {
                let resData = result.data;
                callback(resData);
                return true;
            } else {
                MsgBox.warning(result.message);
                return false;
            }
        }
    });
}

Vue.regist(SwbContractGoodsAreaPriceSave);

// 设置区域价格
export function openContractGoodsAreaPriceDlg(dlgConfig, callback) {
    let operateContract = dlgConfig['operateContract'] || null;
    let disabled = Utils.isTrue(dlgConfig['disabled']);
    let taxRate = dlgConfig['taxRate'] || null;
    let contractGoodsItemId = dlgConfig['contractGoodsItemId'] || null;
    let areaPrices = dlgConfig['areaPrices'] || [];
    let bizFormNameList = dlgConfig['bizFormNameList'] || [];
    let kindId = dlgConfig['kindId'];
    let price = dlgConfig['price'];
    //
    let title = null;
    let okVisible = true;
    let cancelText = '取消';
    if(!Utils.isNoB(operateContract) && operateContract == 'chakan') {
        title = '区域价格 - 查看';
        okVisible = false;
        cancelText = '关闭';
    }
    //
    let theDlg = Vue.$showDialog({
        title: title || '区域价格 - 设置',
        width: 1000,
        height: 750,
        showCloseBtn: true,
        okVisible: okVisible,
        cancelText: cancelText,
        template: '<div class = "">' +
        '<swb-contract-goods-area-price-save :operateContract="operateContract" :disabled="disabled" :taxRate="taxRate" :contractGoodsItemId="contractGoodsItemId" :areaPrices="areaPrices" :bizFormNameList="bizFormNameList" :kindId="kindId" :price="price" ref="swb_contract_goods_area_price_save"></swb-contract-goods-area-price-save>' +
        '</div>',
        data: {
            operateContract: operateContract,
            disabled: disabled,
            taxRate: taxRate,
            contractGoodsItemId: contractGoodsItemId,
            areaPrices: areaPrices,
            bizFormNameList: bizFormNameList,
            kindId: kindId,
            price: price
        },
        okClicked: function () {
            let self = this;
            let result = self.$refs.swb_contract_goods_area_price_save.getDlgResult();
            if(result != null) {
                if(result.type == 'info') {
                    let areaPriceList = result.data;
                    //
                    callback(areaPriceList, theDlg);
                } else {
                    MsgBox.warning(result.message);
                }
            }
            return false;
        },
        lifecycle: {
            created: function () {
            }
        }
    });
}

Vue.regist(SwbContractFormatExpl);

// 合同导入说明
export function openContractFormatExplDlg(scopeId) {
    //
    let theDlg = Vue.$showDialog({
        title: '合同导入说明 - 查看',
        width: 1200,
        height: 800,
        showCloseBtn: true,
        okVisible: false,
        cancelText: '关闭',
        template: '<div class = "">' +
        '<swb-contract-format-expl :scopeId="scopeId" ref="swb_contract_format_expl"></swb-contract-format-expl>' +
        '</div>',
        data: {
            scopeId: scopeId
        },
        okClicked: function () {
        },
        lifecycle: {
            created: function () {
            }
        }
    });
}

Vue.regist(SwbContractImpCheck);

// 合同导入检查
export function openContractImpCheckDlg(fileObj, scopeId, callback) {
    let theDlg = null;
    theDlg = Vue.$showDialog({
        title: '合同导入 - 检查',
        width: -100,
        height: -150,
        okVisible: false,
        cancelVisible: false,
        extVisible: true,
        showCloseBtn: true,
        okText: '整体导入',
        extText: '关闭',
        cancelText: '整体检查',
        template: '<swb-contract-imp-check @other-close="otherClose" :scopeId="scopeId" :rootWidth="dlgBodyWidth" :rootHeight="dlgBodyHeight" :fileObj="fileObj" ref="swb_contract_imp_check"></swb-contract-imp-check>',
        data: {
            scopeId: scopeId,
            fileObj: fileObj,
            dlgBodyWidth: 900,
            dlgBodyHeight: 680
        },
        methods: {
            dlgBodyResized(width, height) {
                this.dlgBodyWidth = width;
                this.dlgBodyHeight = height;
            },
            otherClose() {
                callback({
                    importStatis: null
                });
                theDlg.close();
            }
        },
        okClicked: function () {
        },
        cancelClicked: function () {
        }
    });
}

Vue.regist(SwbContractFeeItemForSelect);

// 合同费用项目，选择列表
export function openContractFeeItemListDlg(dlgConfig, callback) {
    let contractId = dlgConfig['contractId'] || null;
    let selectIds = dlgConfig['selectIds'] || [];
    //
    Vue.$showDialog({
        title: '合同费用项目 - 选择',
        showCloseBtn: true,
        width: 900,
        height: 800,
        template: '<swb-contract-fee-item-list-for-select :contractId="contractId" :selectIds="selectIds" ref="swb_contract_fee_item_list_for_select"></swb-contract-fee-item-list-for-select>',
        data: {
            contractId: contractId,
            selectIds: selectIds,
        },
        methods: {},
        okClicked: function () {
            let selfDlg = this;
            let result = selfDlg.$refs.swb_contract_fee_item_list_for_select.getDlgResult() || {};
            if(result.type == 'info') {
                let resData = result.data || [];
                callback(resData);
                return true;
            } else {
                MsgBox.warning(result.message);
                return false;
            }
        }
    });
}

Vue.regist(SwbContractModify);

// 商品合同修订
export function openContractModifyDlg(dlgConfig, callback) {
    let id = dlgConfig['id'] || null;
    //
    let theDlg = Vue.$showDialog({
        title: '合同 - 修订',
        width: -100,
        height: -50,
        showCloseBtn: true,
        template: '<div class = "">' +
        '<swb-contract-modify :id="id" ref="swb_contract_modify"></swb-contract-modify>' +
        '</div>',
        data: {
            id: id
        },
        okClicked: function () {
            let self = this;
            let result = self.$refs.swb_contract_modify.getDlgResult();
            if(result != null) {
                if(result.type == 'info') {
                    let contract = result.data;
                    //
                    callback(contract, theDlg);
                } else {
                    MsgBox.warning(result.message);
                }
            }
            return false;
        },
        lifecycle: {
            created: function () {
            }
        }
    });
}

Vue.regist(SwbContractServcPurchModify);

// 服务合同修订
export function openContractServcPurchModifyDlg(dlgConfig, callback) {
    let id = dlgConfig['id'] || null;
    let theDlg = Vue.$showDialog({
        title: '合同 - 修订',
        width: -100,
        height: -50,
        showCloseBtn: true,
        template: '<swb-contract-servc-purch-modify :id="id" ref="swb_contract_servc_purch_modify"></swb-contract-servc-purch-modify>',
        data: {
            id: id
        },
        okClicked: function () {
            let self = this;
            let result = self.$refs.swb_contract_servc_purch_modify.getDlgResult();
            if(result != null) {
                if(result.type == 'info') {
                    let contract = result.data || {};
                    //
                    callback(contract, theDlg);
                } else {
                    MsgBox.warning(result.message);
                }
            }
            return false;
        }
    });
}

import SwbContractPhasedPaySettingModify from './ContractPhasedPaySettingModify';

Vue.regist(SwbContractPhasedPaySettingModify);
// 合同付款阶段变更
export function openContractPhasedPaySettingModifyDlg(dlgConfig, callback) {
    let id = dlgConfig['id'] || null;
    //
    let theDlg = Vue.$showDialog({
        title: '合同 - 修订',
        width: -100,
        height: -50,
        showCloseBtn: true,
        template: '<div class = "">' +
            '<swb-contract-phased-pay-setting-modify :id="id" ref="swb_contract_phased_pay_setting_modify"></swb-contract-phased-pay-setting-modify>' +
            '</div>',
        data: {
            id: id
        },
        okClicked: function () {
            let self = this;
            let result = self.$refs.swb_contract_phased_pay_setting_modify.getDlgResult();
            if(result != null) {
                if(result.type == 'info') {
                    //
                    callback(result.data, result.message, theDlg);
                } else {
                    MsgBox.warning(result.message);
                }
            }
            return false;
        },
        lifecycle: {
            created: function () {
            }
        }
    });
}

// 合同-设备服务 选择
export function openContractServcListForSelectDlg(dlgConfig, callback) {
    let params = dlgConfig['params'] || null;
    let selectIds = dlgConfig['selectIds'] || null;
    //
    let theDlg = Vue.$showDialog({
        title: '合同列表 - 选择',
        showCloseBtn: true,
        width: -300,
        height: 750,
        template: '<div>' +
        '<swb-contract-servc-list-for-select :params="params" :selectIds="selectIds" ref="swb_contract_servc_list_for_select"></swb-contract-servc-list-for-select>' +
        '</div>',
        data: {
            params: params,
            selectIds: selectIds
        },
        methods: {},
        okClicked: function () {
            let selfDlg = this;
            let result = selfDlg.$refs.swb_contract_servc_list_for_select.getDlgResult() || {};
            if(!Utils.isNoB(result) && result.type == 'info') {
                let resData = result.data;
                callback(resData, theDlg);
                return true;
            } else {
                MsgBox.warning(result.message);
                return false;
            }
        }
    });
}

Vue.regist(SwbContractServcOrgQuantityList);

// 合同服务门店次限 - 作废
export function openContractServcOrgQuantitySetDlg(dlgConfig, callback) {
    let quantityRevisible = Utils.isNoB(dlgConfig['quantityRevisible']) ? true : dlgConfig['quantityRevisible'];  // 是否允许修订次数
    let showDetail = dlgConfig['showDetail'] || false;  // 仅展示
    let servcModify = dlgConfig['servcModify'] || false;
    let selectComList = dlgConfig['orgQuantityList'] || [];
    let theDlg = Vue.$showDialog({
        title: '门店服务次数',
        showCloseBtn: true,
        okVisible: !showDetail,
        width: -300,
        height: 750,
        template: '<swb-contract-servc-org-quantity-list :quantityRevisible="quantityRevisible" :showDetail="showDetail" :servcModify="servcModify" :selectComList="selectComList" ref="swb_contract_servc_org_quantity_list"></swb-contract-servc-org-quantity-list>',
        data: {
            quantityRevisible: quantityRevisible,
            showDetail: showDetail,
            servcModify: servcModify,
            selectComList: selectComList
        },
        methods: {},
        okClicked: function () {
            let selfDlg = this;
            let result = selfDlg.$refs.swb_contract_servc_org_quantity_list.getDlgResult() || {};
            if(result.type == 'info') {
                let orgQuantityList = result.data || [];
                callback(orgQuantityList);
                theDlg.close();
            } else {
                MsgBox.warning(result.message);
                return false;
            }
        }
    });
}

Vue.regist(SwbContractServcOrgPriceList);

// 合同服务门店次限 - 作废
export function openContractServcOrgPriceSetDlg(dlgConfig, callback) {
    let showDetail = dlgConfig['showDetail'] || false; // 仅查看
    let servcModify = dlgConfig['servcModify'] || false; // 修订
    let servcPrice = dlgConfig['servcPrice'];
    let orgPriceList = dlgConfig['orgPriceList'] || [];
    let contractAppliedShopList = dlgConfig['contractAppliedShopList'] || [];
    let filterMerchantId = dlgConfig['filterMerchantId']; // 是否过滤分管商户
    let theDlg = Vue.$showDialog({
        title: '特定门店价格',
        showCloseBtn: true,
        okVisible: !showDetail,
        width: -300,
        height: 750,
        template: '<swb-contract-servc-org-price-list :filterMerchantId="filterMerchantId" :showDetail="showDetail" :servcModify="servcModify" :servcPrice="servcPrice" :orgPriceList="orgPriceList" :contractAppliedShopList="contractAppliedShopList" ref="swb_contract_servc_org_price_list"></swb-contract-servc-org-price-list>',
        data: {
            showDetail: showDetail,
            servcModify: servcModify,
            servcPrice: servcPrice,
            orgPriceList: orgPriceList,
            contractAppliedShopList: contractAppliedShopList,
            filterMerchantId: filterMerchantId
        },
        methods: {},
        okClicked: function () {
            let selfDlg = this;
            let result = selfDlg.$refs.swb_contract_servc_org_price_list.getDlgResult() || {};
            if(result.type == 'info') {
                let orgPriceList = result.data || [];
                callback(orgPriceList);
                theDlg.close();
            } else {
                MsgBox.warning(result.message);
                return false;
            }
        }
    });
}

Vue.regist(SwbContractServcOrgSpecList);

// 合同服务机构特定设置
export function openContractServcOrgSpecListDlg(dlgConfig, callback) {
    let comnRequire = dlgConfig['comnRequire'] || false;
    let quantityFlag = dlgConfig['quantityFlag'] || false;      // 支持数量
    let quantityRevisible = dlgConfig['quantityRevisible'] || false;    // 数量可修订
    let amountFlag = dlgConfig['amountFlag'] || false;    // 支持总价
    let showDetail = dlgConfig['showDetail'] || false; // 仅查看
    let bianengFlag = dlgConfig['bianengFlag'] || false; // 变更
    let servcModify = dlgConfig['servcModify'] || false; // 修订
    let servcOrgSpecList = dlgConfig['servcOrgSpecList'] || [];
    let contractAppliedShopList = dlgConfig['contractAppliedShopList'] || [];
    let filterMerchantId = dlgConfig['filterMerchantId']; // 是否过滤分管商户
    let title = dlgConfig["title"] || "特定门店价格";
    let theDlg = Vue.$showDialog({
        title: title,
        showCloseBtn: true,
        okVisible: !showDetail,
        width: -300,
        height: 750,
        template: '<swb-contract-servc-org-spec-list :filterMerchantId="filterMerchantId" :comnRequire="comnRequire" :showDetail="showDetail" :servcModify="servcModify" :bianengFlag="bianengFlag" ' +
        ' :servcOrgSpecList="servcOrgSpecList" :contractAppliedShopList="contractAppliedShopList"' +
        ' :quantityFlag="quantityFlag" :quantityRevisible="quantityRevisible" :amountFlag="amountFlag" ref="swb_contract_servc_org_price_list"></swb-contract-servc-org-spec-list>',
        data: {
            comnRequire: comnRequire,
            quantityFlag: quantityFlag,
            quantityRevisible: quantityRevisible,
            amountFlag: amountFlag,
            //
            showDetail: showDetail,
            servcModify: servcModify,
            bianengFlag: bianengFlag,
            servcOrgSpecList: servcOrgSpecList,
            contractAppliedShopList: contractAppliedShopList,
            filterMerchantId: filterMerchantId
        },
        methods: {},
        okClicked: function () {
            let selfDlg = this;
            let result = selfDlg.$refs.swb_contract_servc_org_price_list.getDlgResult() || {};
            if(result.type == 'info') {
                let orgPriceList = result.data || [];
                callback(orgPriceList);
                theDlg.close();
            } else {
                MsgBox.warning(result.message);
                return false;
            }
        }
    });
}

export function openShowContractServcOrgPriceRecListDlg(dlgConfig) {
    let comnRequire = dlgConfig['comnRequire'] || false;
    let originalServcItemId = dlgConfig['originalServcItemId'];
    let bizUnitId = dlgConfig['bizUnitId'];
    let servcQuantity = dlgConfig['servcQuantity'];
    let amount = dlgConfig['amount'] || 0.00;
    let price = dlgConfig['price'] || 0.00;
    let lastPrice = dlgConfig['lastPrice'] || 0.00;
    let theDlg = Vue.$showDialog({
        title: '单次价格预览',
        showCloseBtn: true,
        okVisible: false,
        width: 800,
        height: 750,
        template: '<swb-contract-servc-org-price-rec-list :comnRequire="comnRequire" :originalServcItemId="originalServcItemId" :bizUnitId="bizUnitId" :servcQuantity="servcQuantity"' +
        ':amount="amount" :price="price" :lastPrice="lastPrice" ref="swb_contract_servc_org_price_rec_list"></swb-contract-servc-org-price-rec-list>',
        data: {
            comnRequire: comnRequire,
            originalServcItemId: originalServcItemId,
            bizUnitId: bizUnitId,
            servcQuantity: servcQuantity,
            //
            amount: amount,
            price: price,
            lastPrice: lastPrice
        },
        methods: {},
        okClicked: function () {
        }
    });
}



//////////////////
// WEBPACK FOOTER
// ./src/compo/contract/dialog.js
// module id = 86
// module chunks = 0